import "./JoinUsBlock.css";

function JoinUs({ smallTitle, heading, description, buttonText, image }) {
  return (
    <section className="block joinus">
      <div className="joinus-content">

        <div className="joinus-text">
          <h4>{smallTitle || ''}</h4>
          <h2>{heading || ''}</h2>

          <p>
            {description || ''}
          </p>

          <button>{buttonText || ''}</button>
        </div>

        <div className="joinus-image">
          {image && <img src={image} alt="Team" />}
        </div>

      </div>
    </section>
  );
}

export default JoinUs;
